<template>
  <div class="stats-card">
    <div class="card-header">
      <div class="icon-container">
        <slot name="icon"></slot>
      </div>
      <div class="stats">
        <div class="primary-block">
          <span class="number" v-text="stat.toString()" />
        </div>
      </div>
    </div>
    <div>
      <span class="label" v-text="label" />
    </div>
  </div>
</template>

<style lang="scss" scoped>

  .stats-card {
    gap: 8px;
    flex-direction: column;
    align-items: start;
    padding: 24px;
  }

  .card-header {
    display: flex;
    flex-direction: row;
    gap: 8px;
  }

  .icon-container {
    width: 40px !important;
    height: 40px !important;
  }

  .stats {
    .number {
      font-size: 26px !important;
    }
  }

</style>

<script setup>
defineProps({
  stat: {
    type: Number,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});
</script>